module.exports = __webpack_public_path__ + "4c5b21433c28c2921d61335a752f61a1.svg";